import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { useApplicationEvent } from '../../../../../core/Analytics/useApplicationEvent';
import { ApplicationEvent } from '../../../../../models/analytics';
import { ConsumedHandoffSession } from '../../../../../models/handoffSession';
import { updateHandoffSession as updateHandoffSessionImport } from '../../../../../lib-api/services/HandoffSession';
import { Transfer } from '../../../../DirectPayments/models/transfer';
import { AppState, ConnectedPropsWithoutDispatch } from '../../../../../stores/redux-store';
import { HandoffPayError as HandoffPayErrorImport } from './organisms/HandoffPayError/HandoffPayError';
import { HandoffPayInitiator as HandoffPayInitiatorImport } from './organisms/HandoffPayInitiator/HandoffPayInitiator';
import { HandoffPayCredentialsHandler as HandoffPayCredentialsHandlerImport } from './organisms/HandoffPayCredentialsHandler/HandoffPayCredentialsHandler';

export type DeviceHandoffPayOwnProps = {
  HandoffPayCredentialsHandler?: React.ComponentType;
  HandoffPayInitiator?: React.ComponentType;
  HandoffPayError?: React.ComponentType;
  updateHandoffSession?: typeof updateHandoffSessionImport;
};

export type DeviceHandoffPayProps = DeviceHandoffPayOwnProps & PropsFromRedux;

export const DeviceHandoffPayPresenter: React.FC<DeviceHandoffPayProps> = ({
  transfer,
  handoffSession,
  HandoffPayCredentialsHandler = HandoffPayCredentialsHandlerImport,
  HandoffPayInitiator = HandoffPayInitiatorImport,
  HandoffPayError = HandoffPayErrorImport,
  updateHandoffSession = updateHandoffSessionImport,
}) => {
  const handoffSessionId = handoffSession?.id;

  const { sendEvent } = useApplicationEvent();

  useEffect(() => {
    if (handoffSession) {
      sendEvent(ApplicationEvent.PROVIDER_AUTHENTICATION_INITIALIZED);
    }
  }, [handoffSession, sendEvent]);

  useEffect(() => {
    if ((transfer?.id && Transfer.isAwaiting(transfer)) || Transfer.isFailed(transfer)) {
      updateHandoffSession({
        transferId: transfer?.id,
        handoffSessionId,
      });
    }
  }, [handoffSessionId, updateHandoffSession, transfer]);

  if (!transfer) {
    return <HandoffPayInitiator />;
  }

  if (Transfer.isFailed(transfer)) {
    return <HandoffPayError />;
  }

  return <HandoffPayCredentialsHandler />;
};

const mapStateToProps = (state: AppState) => {
  return {
    transfer: state.transfer.data,
    handoffSession: state.handoffSession.data as ConsumedHandoffSession,
  };
};

const connector = connect(mapStateToProps);

type PropsFromRedux = ConnectedPropsWithoutDispatch<typeof connector>;

export const DeviceHandoffPay = connector(DeviceHandoffPayPresenter);
